module.exports = __webpack_public_path__ + "img/questions-bg.6ae1e2a6.webp";